import React from "react";

import { componentNanoid } from "../../utils/componentNanoid";
import formatSearchResults from "../SearchContents/formatSearchResults";
import { composeTableData, composeTableHeaders } from "./composeTableData";
import { useSearchResults } from "../../context/DataContext";

import BodyRow from "./BodyRow";
import HeaderRow from "./HeaderRow";
import { ResultColumn } from "../SearchContents/SearchResults";
import { SearchResultsHeader } from "../SearchContents/SearchContents";

import styles from "./SearchResultsTable.module.css";

export type SearchResultsTableProps = {
    itemDefs: ResultColumn[];
};

const SearchResultsTable = ({ itemDefs }: SearchResultsTableProps) => {
    const { results } = useSearchResults();
    const rawItems = formatSearchResults(results, itemDefs);
    const headers = composeTableHeaders(itemDefs);
    const items = composeTableData(headers, rawItems);
    const maybeTable =
        headers.length && items.length && headers.length === items[0].length ? (
            <div className={styles.wrapper}>
                <table>
                    <HeaderRow headers={headers as SearchResultsHeader[]} />
                    <tbody>
                        {items.map((row) => (
                            <BodyRow
                                key={`row-${componentNanoid()}`}
                                cells={row}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        ) : null;
    return maybeTable;
};

export default SearchResultsTable;
